<script lang="ts" setup>
import type { DataTableFilterMetaData } from 'primevue/datatable';
import { computed } from 'vue';
import VSearch from '../VSearch/VSearch.vue';

const { autofocus = true } = defineProps<{ autofocus?: boolean }>();

const model = defineModel<Record<string | number | symbol, DataTableFilterMetaData>>({
  default: {},
});

function updateModelValue(value: string) {
  model.value = {
    ...model.value,
    global: { matchMode: 'contains', value },
  };
}

const inputValue = computed({
  get: () => model.value.global?.value,
  set: updateModelValue,
});
</script>

<template>
  <VSearch :auto-focus="autofocus" v-model="inputValue" placeholder="Zoeken..." />
</template>
